module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": "text",
      "button-class": _vm.buttonStyle,
      "heading": "Tower Provider Sites",
      "button-text": _vm.name,
      "button-size": "mini",
      "show-save": false,
      "button-icon": "fa fa-grid"
    }
  }, [_c('popup-sites-report', {
    attrs: {
      "name": _vm.name,
      "site-group": _vm.siteGroup,
      "supplier-id": _vm.supplierId,
      "status": _vm.status
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed90533"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sites/SitesPopup.vue
// module id = 1398
// module chunks = 0